import {i18n} from '@/i18n/index';

export default function getLan(key) {
  const { t } = i18n.global;
  let translation = t(`HitoolsDesignerHeatMap.${key}`);

  // 如果翻译为空字符串，返回key作为fallback
  if (translation === '') {
    return key;
  }


  return translation;
}
